import { cancelPendingRequest, client } from '@/api/client'
import type { CalculationInput, CalculationResult } from '@/types/calculation'

/**
 * Posts to the proxy route on the corporate website, registered in
 * net-metering/_config/config.yml. Fixed and same origin, so it is not configurable from the CMS.
 *
 * The trailing slash is required: every extensionless path without one gets a 301 to the same path
 * with a slash, which turns the POST into a GET and gets a 405 from the proxy.
 */
export async function requestCalculation(input: CalculationInput): Promise<CalculationResult> {
  const response = await client.post<CalculationResult>('/api/net-metering/calculation/', input, {
    signal: cancelPendingRequest('net-metering.calculation'),
  })

  return response.data
}
